import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projCtrAcctList: [],
  projCtrAcctInfo: {
    ctrAcctId: '',
    type: '',
    status: '',
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  projCtrAcctDDList: [],
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjCtrAcct({
    dispatch,
    commit,
    state
  }, {ctrAcctId, projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_CTR_ACCT, {
      data: {
        type: state.projCtrAcctInfo.type,
        status: state.projCtrAcctInfo.status,
        //
        ctrAcctId: ctrAcctId,
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjCtrAcct({
    dispatch,
    commit,
    state
  }, {ctrAcctId, projId, compId, codeParam}) {
    let projCtrAcctInfo = {
      type: state.projCtrAcctInfo.type,
      status: state.projCtrAcctInfo.status,
      //
      key: {
        ctrAcctId: ctrAcctId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_CTR_ACCT, {
      data: projCtrAcctInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjCtrAcct({
    commit,
    state
  }, {ctrAcctId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_CTR_ACCT + `?ctrAcctId=${ctrAcctId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjCtrAcctList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_CTR_ACCT_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjCtrAcctList', response)
  },
  async findProjCtrAcctDDList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_CTR_ACCT_DD_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjCtrAcctDDList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateCtrAcctId(state, value) {
    state.projCtrAcctInfo.ctrAcctId = value
  },
  updateType(state, value) {
    state.projCtrAcctInfo.type = value
  },
  updateStatus(state, value) {
    state.projCtrAcctInfo.status = value
  },
  updateProjCtrAcctList(state, response) {
    if (response.success === true && response.data.length) {
      state.projCtrAcctList = response.data
    } else {
      state.projCtrAcctList = []
    }
  },
  updateProjCtrAcctDDList(state, response) {
    if (response.success === true && response.data.length) {
      state.projCtrAcctDDList = Utils.toListWapper(response.data, {valueField: 'ctrAcctId', descrField: 'acctName'})
    } else {
      state.projCtrAcctDDList = []
    }
  },
  updateProjCtrAcctListEmpty(state) {
    state.editIndex = -1
    state.projCtrAcctList = []
  },
  updateProjCtrAcctEmpty(state) {
    state.projCtrAcctInfo.ctrAcctId = ''
    state.projCtrAcctInfo.type = ''
    state.projCtrAcctInfo.status = ''
    state.projCtrAcctInfo.crtBy = ''
    state.projCtrAcctInfo.crtOn = new Date(0)
    state.projCtrAcctInfo.updBy = ''
    state.projCtrAcctInfo.updOn = new Date(0)

    state.projCtrAcctInfo.indUsed = ''
  },
  updateProjCtrAcctInfo(state, projCtrAcctInfo) {
    // debugger
    state.projCtrAcctInfo.ctrAcctId = projCtrAcctInfo.ctrAcctId
    state.projCtrAcctInfo.type = projCtrAcctInfo.type
    state.projCtrAcctInfo.status = projCtrAcctInfo.status
    state.projCtrAcctInfo.crtBy = projCtrAcctInfo.crtBy
    state.projCtrAcctInfo.crtOn = projCtrAcctInfo.crtOn
    state.projCtrAcctInfo.updBy = projCtrAcctInfo.updBy
    state.projCtrAcctInfo.updOn = projCtrAcctInfo.updOn
    //
    state.projCtrAcctInfo.indUsed = projCtrAcctInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjCtrAcctManage/updateProjCtrAcctEmpty')
    let obj = {...state.projCtrAcctInfo}
    // debugger
    obj.isBottomRow = true
    state.projCtrAcctList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId, status}) {
    // debugger
    this.commit('confProjCtrAcctManage/updateProjCtrAcctEmpty')
    this.commit('confProjCtrAcctManage/updateEditIndex', index)
    this.commit('confProjCtrAcctManage/updateEditAction', 'insert')
    //
    this.commit('confProjCtrAcctManage/updateCtrAcctId', ctrAcctId)
    this.commit('confProjCtrAcctManage/updateStatus', status)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjCtrAcctManage/updateProjCtrAcctInfo', row)
    this.commit('confProjCtrAcctManage/updateEditIndex', index)
    this.commit('confProjCtrAcctManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjCtrAcctManage.js